import { z } from 'zod'

export const ADMINFORMSMODULESGET_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsModulesGetResponseSchema = z.unknown()
export type AdminFormsModulesGetResponse = z.infer<typeof adminFormsModulesGetResponseSchema>
